import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import visionImage from "../assets/images/vision.jpg";
import heroBg from "../assets/images/HeroBanner.png";
import "../styles/AiotaOurMissionVision.css"; // Import CSS
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import { MdArrowOutward } from "react-icons/md";

const OurVisionMission = () => {
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));
  const navigate = useNavigate();

  const handleMemberLogin = () => {
    navigate("/member-login");
  };

  const handleEdcclogin = () => {
    navigate("/edcc-login");
  };

  const handleClick = () => {
    window.open(
      "https://aiota-live.s3.ap-south-1.amazonaws.com/site/vision/vison_mission.pdf",
      "_blank",
      "noopener,noreferrer"
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState) {
        setTokenState(currentToken);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [tokenState]);
  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">
              All India Occupational Therapists' Association
            </h1>
            {!tokenState && (
              <div className="hero-buttons">
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate login
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container">
          <section className="vision-section">
            <Container>
              <h2>Our Vision & Mission</h2>
              <Row>
                <Col lg={6} className="mb-4 col-12">
                  <p>
                    The "Vision & Mission" document from the All India
                    Occupational Therapists' Association (AIOTA) provides a
                    concise overview of the organization's long-term goals and
                    strategic direction...
                  </p>
                  <p>
                    The vision emphasizes the aspiration to position
                    occupational therapy as an essential, recognized component
                    of the nation’s health and rehabilitation system...
                  </p>
                  <p>
                    Together, these elements serve to guide AIOTA’s initiatives
                    and affirm its role as a leading authority in the field.The
                    vision emphasizes the aspiration to position occupational
                    therapy as an essential, recognized component of the
                    nation’s health and rehabilitation system. The mission
                    highlights AIOTA’s dedication to enhancing professional
                    standards, fostering academic growth through its Academic
                    Council of Occupational Therapy (ACOT), advocating for
                    policy reforms, and raising public awareness about the value
                    of occupational therapy.The vision emphasizes the aspiration
                    to position occupational therapy as an essential, recognized
                    component of the nation’s health and rehabilitation system.
                    The mission highlights AIOTA’s dedication to enhancing
                    professional standards, fostering academic growth through
                    its Academic Council of Occupational Therapy (ACOT),
                    advocating for policy reforms, and raising public awareness
                    about the value of occupational therapy.
                  </p>
                  <div style={{ marginTop: "2rem" }}>
                    <h5 style={{ display: "flex", alignItems: "center" }}>
                      <span className="vision-icon-circle">
                        <span className="material-symbols-outlined vision-arrow">
                          <MdArrowOutward size={20} />
                        </span>
                      </span>
                      <strong style={{ marginLeft: "10px" }}>Vision</strong>
                    </h5>
                    <p>
                      A forward-looking statement describing the future AIOTA
                      aims to achieve—probably positioning itself as a leading
                      body in occupational therapy standards, education, and
                      public health contributions across India.
                    </p>

                    <h5 style={{ display: "flex", alignItems: "center" }}>
                      <span className="vision-icon-circle">
                        <span className="material-symbols-outlined vision-arrow">
                          <MdArrowOutward size={20} />
                        </span>
                      </span>
                      <strong style={{ marginLeft: "10px" }}>Mission</strong>
                    </h5>
                    <p>
                      The key strategies and commitments that AIOTA pledges to
                      adopt to fulfill its vision, such as enhancing quality in
                      therapy education (UG & PG), raising practice standards,
                      influencing policy, and promoting public awareness of
                      occupational therapy.
                    </p>
                  </div>
                  <Button className="w-auto d-flex justify-content-between align-items-center" onClick={handleClick}>
                    READ MORE
                    <FaArrowRight size={24} className="ms-3" />
                  </Button>
                </Col>

                <Col md={6} className=" text-end d-none d-lg-block">
                  <div className="image-container">
                    <img
                      src={visionImage}
                      alt="Vision & Mission"
                      className="vision-image"
                    />
                    {/* <button className="read-more-button">
                      READ MORE
                      <span className="material-symbols-outlined">
                        arrow_forward
                      </span>
                    </button> */}
                  </div>
                </Col>
              </Row>

              {/* <Row>
                <Col md={12}>
                  <div style={{ marginTop: "2rem" }}>
                    <h5 style={{ display: "flex", alignItems: "center" }}>
                      <span className="vision-icon-circle">
                        <span className="material-symbols-outlined vision-arrow">
                          arrow_outward
                        </span>
                      </span>
                      <strong style={{ marginLeft: "10px" }}>Vision</strong>
                    </h5>
                    <p>
                      A forward-looking statement describing the future AIOTA
                      aims to achieve—probably positioning itself as a leading
                      body in occupational therapy standards, education, and
                      public health contributions across India.
                    </p>

                    <h5 style={{ display: "flex", alignItems: "center" }}>
                      <span className="vision-icon-circle">
                        <span className="material-symbols-outlined vision-arrow">
                          arrow_outward
                        </span>
                      </span>
                      <strong style={{ marginLeft: "10px" }}>Mission</strong>
                    </h5>
                    <p>
                      The key strategies and commitments that AIOTA pledges to
                      adopt to fulfill its vision, such as enhancing quality in
                      therapy education (UG & PG), raising practice standards,
                      influencing policy, and promoting public awareness of
                      occupational therapy.
                    </p>
                  </div>
                </Col>
              </Row> */}
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default OurVisionMission;
